import React from 'react'
import AdminNavigation from './AdminNavigation'
import { api } from '../index.api'
import InputGroup from '../../forms/InputGroup'
import { validateField, submitForm } from '../../pages/functions'
import Datetime from 'react-datetime'
import approve, { value } from 'approvejs'
import { addNotification as notify } from 'reapop'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import Textarea from '../../forms/Textarea'
import Select from '../../forms/Select'
import SelectMultiple from '../../forms/SelectMultiple'
import {
  SITE_LANGUAGES_ENGLISH,
  TABLE_HEADER_COLUMN_NO_SORT
} from '../../constants'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

class ManageSiteMessages extends React.Component {
  constructor (props) {
    super(props)
    const siteMsgFields = {
      messageType: {
        name: 'messageType',
        value: '',
        rules: { title: 'Type', required: true }
      },
      showIcon: {
        name: 'showIcon',
        value: '',
        rules: { title: 'Icon', required: true }
      },
      language: {
        name: 'language',
        value: '',
        rules: { title: 'Language', required: true }
      },
      title: {
        name: 'title',
        value: '',
        rules: { title: 'Title (optional) You can also enter [DEFAULT]' }
      },
      message: {
        name: 'message',
        value: '',
        rules: { title: 'Message', required: true, max: 4096 }
      },
      countrySelectionType: {
        name: 'countrySelectionType',
        value: '',
        rules: { title: 'Country Selection', required: true }
      },
      countries: {
        name: 'countries',
        value: '',
        rules: { title: 'Countries' },
        errors: []
      },
      messageAppearance: {
        name: 'messageAppearance',
        value: '',
        rules: { title: 'Appearance', required: true }
      },
      startDate: {
        name: 'startDate',
        value: '',
        rules: { title: 'Start date UTC (YYYY-MM-DD)', required: true }
      },
      endDate: {
        name: 'endDate',
        value: '',
        rules: { title: 'End date UTC (YYYY-MM-DD)', required: true }
      },
      startDownTime: {
        name: 'startDownTime',
        value: '',
        rules: { title: 'Start time UTC (HH:MM)', required: true }
      },
      endDownTime: {
        name: 'endDownTime',
        value: '',
        rules: { title: 'End time UTC (HH:MM)', required: true }
      }
    }

    // Create a deep copy
    const siteMsgEditFields = JSON.parse(JSON.stringify(siteMsgFields))

    this.includeLinkComment = 'Use the following format to include a link in the message: [[Link|your url|your link Text]]'
    this.countryOptions = []
    this.siteMsgTypeOptions = [
      { value: 'ALERT', label: 'Alert' },
      { value: 'ANNOUNCEMENT', label: 'Announcement' },
      { value: 'INFO', label: 'Information' },
      { value: 'MAINT', label: 'Maintenance' }
    ]
    this.showIconOptions = [
      { value: 'N', label: 'No' },
      { value: 'Y', label: 'Yes' }
    ]
    this.siteMsgAppearanceOptions = [
      { value: 'EMBEDDED', label: 'Embedded' },
      { value: 'POPUP', label: 'Popup' }
    ]
    this.countrySelectionTypeOptions = [
      { value: 'ALL', label: 'All countries' },
      { value: 'SUBSET', label: 'I want to select the countries' },
      { value: 'REGION:EEMEA', label: 'Eastern Europe, Middle East, Africa (EEMEA)' },
      { value: 'REGION:JAPAC', label: 'Japan and Asia-Pacific (JAPAC)' },
      { value: 'REGION:LA', label: 'Latin America (LA)' },
      { value: 'REGION:US', label: 'US and Territories' }
    ]
    this.siteMsgs_PER_PAGE = 10
    this.siteMsgs = []
    this.state = {
      currentPage: 0,

      // each siteMsg has a(n):
      // 1. id
      // 2. messageType
      // 3. showIcon
      // 4. language
      // 5. title
      // 6. message
      // 7. countries
      // 8. messageAppearance
      // 9. startDate
      // 10. endDate
      siteMsgs: [[]],
      sortColumn: 'startDate',
      sortDirection: 'down',
      fields: siteMsgFields,
      filterValue: '',

      siteMsgsLength: 0,

      // format = { index, column, value }
      // need to reset when leaving current page or filtering
      edit: null,
      siteMsgEditIsOpenModal: false,
      siteMsgEditFields: siteMsgEditFields,
      siteMsgEdit: null,
      createTranslationFields: {
        language: {
          name: 'language',
          value: '',
          rules: { title: 'Language', required: true }
        },
        title: {
          name: 'title',
          value: '',
          rules: { title: 'Title (optional) You can also enter [DEFAULT]' }
        },
        translation: {
          name: 'translation',
          value: '',
          rules: { title: 'Translation', required: true, max: 4096 }
        }
      }
    }
  }

  addSiteMsgCustomFields = item => {
    item.countryNamesDelimited = this.handleCountryListDisplay(item.countryCodesDelimited)
    // Create top level properties for sorting
    item.siteMessageTypeSort = item.siteMessageType.type
    item.siteMessageAppearanceSort = item.siteMessageAppearance.appearance
    item.siteLanguageSort = item.siteLanguage.language

    return item
  }

  loadSiteMsgList = defaultSortColumnName => {
    api.getAllSiteMessages(siteMsgs => {
      siteMsgs.map(item => this.addSiteMsgCustomFields(item))

      this.siteMsgs = siteMsgs
      this.setState({ siteMsgsLength: this.siteMsgs.length })

      if (defaultSortColumnName == null) {
        this.handleSort()
      } else {
        this.handleSort(defaultSortColumnName)
      }
    })
  }

  componentDidMount () {
    // Important: Load country list before loading the messages
    // It is needed to translate country codes to names for list display
    this.getCountryList()
    this.loadSiteMsgList('startDate')
  }

  getCountryList = () => {
    api.fetchCountriesList(data => {
      this.countryOptions = data.COUNTRY.map(item => ({
        value: item.abbrevation,
        label: item.name
      }))
    })
  }

  handleFilterList = event => {
    const filterValue = event.target.value
    const filteredsiteMsgs = this.siteMsgs.filter(siteMsg => {
      return (
        siteMsg.title.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.message.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.countryNamesDelimited.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.siteMessageType.type.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.siteMessageAppearance.appearance.toLowerCase()
          .includes(filterValue.toLowerCase()) ||
        siteMsg.siteLanguage.language.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.startDate.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.endDate.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.startDownTime.toLowerCase().includes(filterValue.toLowerCase()) ||
        siteMsg.endDownTime.toLowerCase().includes(filterValue.toLowerCase())
      )
    })
    const siteMsgs = this.paginate(filteredsiteMsgs)
    this.setState({
      siteMsgs,
      currentPage: 0,
      filterValue,
      edit: null,
      siteMsgsLength: filteredsiteMsgs.length
    })
  }

  handlePageForward = () => {
    this.setState(state => ({
      currentPage:
        state.currentPage === this.state.siteMsgs.length - 1
          ? state.currentPage
          : state.currentPage + 1,
      edit: null
    }))
  }

  handlePageBackward = () => {
    this.setState(state => ({
      currentPage: state.currentPage === 0 ? 0 : state.currentPage - 1,
      edit: null
    }))
  }

  handlePageNav = currentPage => {
    this.setState({ currentPage, edit: null })
  }

  paginate = arr => {
    if (arr.length <= this.siteMsgs_PER_PAGE) {
      return [arr]
    }
    const sorted = []
    let intermediateArr = []
    let i = 0
    for (const idx in arr) {
      intermediateArr.push(arr[idx])
      if (i === this.siteMsgs_PER_PAGE - 1) {
        sorted.push(intermediateArr)
        i = 0
        intermediateArr = []
      } else {
        i++
      }
    }
    intermediateArr.length !== 0 && sorted.push(intermediateArr)
    return sorted
  }

  handleResetCreateMessage = () => {
    const { fields } = this.state
    for (var key in fields) {
      fields[key].value = ''
      fields[key].errors = []
    }
    this.setState({ fields })
  }

  handleResetCreateTranslation = () => {
    const { createTranslationFields } = this.state
    for (var key in createTranslationFields) {
      createTranslationFields[key].value = ''
      createTranslationFields[key].errors = []
    }
    this.setState({ createTranslationFields })
  }

  mapColumnNameToSortColumn = columnName => {
    let sortColumn = columnName
    switch (columnName) {
      case 'messageType':
        sortColumn = 'siteMessageTypeSort'
        break
      case 'messageAppearance':
        sortColumn = 'siteMessageAppearanceSort'
        break
      case 'language':
        sortColumn = 'siteLanguageSort'
        break
      default:
        break
    }
    return sortColumn
  }

  handleSort = columnName => {
    const sortColumn = this.mapColumnNameToSortColumn(columnName)

    this.setState(() => {
      const filterValue = ''
      let siteMsgs = this.siteMsgs
      // if sortColumn not passed, sort using existing selection
      if (!sortColumn) {
        siteMsgs.sort((a, b) => {
          if (this.state.sortDirection === 'down') {
            if (a[this.state.sortColumn] < b[this.state.sortColumn]) {
              return -1
            }
            if (a[this.state.sortColumn] > b[this.state.sortColumn]) {
              return 1
            }
          } else {
            if (a[this.state.sortColumn] > b[this.state.sortColumn]) {
              return -1
            }
            if (a[this.state.sortColumn] < b[this.state.sortColumn]) {
              return 1
            }
          }
          return 0
        })
        siteMsgs = this.paginate(siteMsgs)
        return { siteMsgs, filterValue }
      } else {
        let sortDirection = 'down'
        siteMsgs.sort((a, b) => {
          if (
            this.state.sortColumn !== sortColumn ||
            this.state.sortDirection === 'up'
          ) {
            if (a[sortColumn] < b[sortColumn]) {
              return -1
            }
            if (a[sortColumn] > b[sortColumn]) {
              return 1
            }
          } else {
            sortDirection = 'up'
            if (a[sortColumn] > b[sortColumn]) {
              return -1
            }
            if (a[sortColumn] < b[sortColumn]) {
              return 1
            }
          }
          return 0
        })
        siteMsgs = this.paginate(siteMsgs)
        return {
          siteMsgs,
          sortColumn,
          sortDirection,
          filterValue,
          siteMsgsLength: this.siteMsgs.length,
          edit: null
        }
      }
    })
  }

  handleSubmitCreateMessage = e => {
    const siteMsg = this.handleSubmitExtractFormData(e, this.state.fields, 'Create')
    if (siteMsg == null) { return false }

    this.handleSubmitCallApi(e, siteMsg, 'Create')
  }

  handleSubmitEditMessage = e => {
    const siteMsg = this.handleSubmitExtractFormData(e, this.state.siteMsgEditFields, 'Edit')
    if (siteMsg == null) { return false }

    this.handleSubmitCallApi(e, siteMsg, 'Edit')
  }

  handleTranslationDeletion = (e, languageCode) => {
    const msg = 'Are you sure you want to delete this translation?'
    if (!window.confirm(msg)) {
      return false
    }

    const siteMsgEdit = this.state.siteMsgEdit
    const translations = siteMsgEdit.translations.filter(item => item.siteLanguage.code !== languageCode)
    siteMsgEdit.translations = translations
    this.handleSubmitCallApi(e, siteMsgEdit, 'Delete Translation')

    return true
  }

  handleSubmitCreateTranslation = e => {
    const fields = submitForm(e, this.state.createTranslationFields)

    for (var key in fields) {
      if (fields[key].errors.length > 0) {
        this.setState({ createTranslationFields: fields })
        return false
      }
    }

    const siteMsg = this.state.siteMsgEdit
    const language = fields.language
    const title = fields.title
    const translation = fields.translation

    let existingTranslation = null
    if (siteMsg.translations) {
      existingTranslation = siteMsg.translations.filter(tran => tran.siteLanguage.code === language.value)

      if (existingTranslation) {
        existingTranslation.titleTranslation = title.value
        existingTranslation.messageTranslation = encodeURIComponent(translation.value)
      }
    }

    // Delete existing
    if (siteMsg.translations) {
      siteMsg.translations = siteMsg.translations.filter(tran => tran.siteLanguage.code !== language.value)

      if (siteMsg.translations == null) {
        siteMsg.translations = []
      }
    } else {
      siteMsg.translations = []
    }

    // Add new or existing (important to keep id of existing)
    siteMsg.translations.push(
      {
        id: existingTranslation && existingTranslation.length > 0 ? existingTranslation[0].id : 0,
        siteLanguage: {
          code: language.value,
          language: SITE_LANGUAGES_ENGLISH.filter(lang => lang.value === language.value)[0].label
        },
        titleTranslation: title.value,
        messageTranslation: encodeURIComponent(translation.value)
      }
    )

    this.handleSubmitCallApi(e, siteMsg, 'Create Translation')
  }

  handleSubmitExtractFormData = (e, relatedStateFields, actionType) => {
    const fields = submitForm(e, relatedStateFields)

    if (fields.countrySelectionType.value === 'SUBSET' && fields.countries.value === '') {
      fields.countries.errors.push('Select one or more countries')
      this.setState({ fields })
      return null
    }

    for (var key in fields) {
      if (fields[key].errors.length > 0) {
        this.setState({ fields })
        return null
      }
    }

    const formatCountriesDelimited = fields => {
      if (fields.countrySelectionType.value !== 'SUBSET') {
        return fields.countrySelectionType.value
      }

      return '|' + fields.countries.value.replace(/,/gi, '|') + '|'
    }

    const siteMsg = {
      id: actionType === 'Create' ? 0 : this.state.siteMsgEdit.id,
      siteLanguage: {
        code: fields.language.value,
        language: ''
      },
      siteMessageType: {
        code: fields.messageType.value,
        type: ''
      },
      showIcon: fields.showIcon.value,
      siteMessageAppearance: {
        code: fields.messageAppearance.value,
        appearance: ''
      },
      title: fields.title.value,
      message: encodeURIComponent(fields.message.value),
      translations: actionType === 'Create' ? [] : this.state.siteMsgEdit.translations,
      countryCodesDelimited: formatCountriesDelimited(fields),
      startDate: fields.startDate.value,
      endDate: fields.endDate.value,
      startDownTime: fields.startDownTime.value,
      endDownTime: fields.endDownTime.value
    }

    if (actionType === 'Edit') {
      // In case site msg language was changed, remove the translation with the new language
      // Example: If a message in English is changed to German -> remove the German translation
      siteMsg.translations = siteMsg.translations.filter(tran => tran.siteLanguage.code !== siteMsg.siteLanguage.code)
    }

    return siteMsg
  }

  handleSubmitCallApi = (e, siteMsg, actionType) => {
    api.createOrUpdateSiteMessage(
      siteMsg,
      data => {
        const responseSiteMsg = this.addSiteMsgCustomFields(data)

        // Replace obj in list
        this.siteMsgs = this.siteMsgs.filter(item => item.id !== responseSiteMsg.id)
        this.siteMsgs.push(responseSiteMsg)
        this.handleSort()

        // create toaster notification
        const { notify } = this.props
        const notification = {
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }

        switch (actionType) {
          case 'Create':
            this.handleResetCreateMessage()
            window.scrollTo({ top: 0, behavior: 'smooth' })
            break
          case 'Edit':
            this.handleHideSiteMessageEditModal()
            break
          case 'Create Translation':
            this.handleResetCreateTranslation()
            this.setState({ siteMsgEdit: responseSiteMsg })
            break
          case 'Delete Translation':
            this.setState({ siteMsgEdit: responseSiteMsg })
            break
          default:
            break
        }

        notification.title = 'Success!'
        notification.message = actionType === 'Create' ? 'Message was created' : 'Message was saved'
        notification.status = 'success'
        notify(notification)

        //  ------------------------------------
        // [Ran 20200602] This success handler was modifid to get json object with new siteMsg instead of response object.
        // The change was made to be able to use the siteMsg returned from the post request.
        // Returned siteMsg had translation ids for newly added translations and is used to replace the msg in state.siteMsgEdit and this.siteMsgs
        // See api.createOrUpdateSiteMessage() promises for handling of HTTP Status error codes (400, 401)
        //  ------------------------------------
        // if (response.status === 201) {
        //   notification.title = 'Success!'
        //   notification.message = actionType === 'Create' ? 'Message was created' : 'Message was saved'
        //   notification.status = 'success'
        //   notify(notification)
        //
        //   this.loadSiteMsgList()
        // } else {
        //   notification.title = 'Error!'
        //   notification.status = 'error'
        //   if (response.status === 400) {
        //     response.text().then(errorMessage => {
        //       notification.message = errorMessage
        //       notify(notification)
        //     })
        //   } else if (response.status === 401) {
        //     notification.message =
        //       'You are not authorized to perform this action. Please log in again.'
        //     notify(notification)
        //     setTimeout(() => window.location.replace('/'), 3000)
        //   } else {
        //     notification.message = 'Something went wrong. Please try again later'
        //     notify(notification)
        //   }
        // }
      },
      ex => {
        let errorMessage = 'Please try again later.'

        if (ex.message.includes('HTTP_STATUS:400:ErrorMessage:')) {
          errorMessage = `Error: ${ex.message.replace('HTTP_STATUS:400:ErrorMessage:', '')}`
        } else if (ex.message.includes('HTTP_STATUS:401')) {
          errorMessage = 'You are not authorized to perform this action. Please log in again.'
        }

        const { notify } = this.props
        notify({
          title: 'Error!',
          message: errorMessage,
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        })
      }
    )
  }

  validate = (e, field) => {
    const fields = validateField(e, field, this.state.fields)
    this.setState({ fields })
  }

  validateDatetime = (moment, field) => {
    const date =
      typeof moment === 'string' ? moment : moment.format('YYYY-MM-DD')
    const { fields } = this.state
    field.value = date
    const result = approve.value(date, field.rules)
    field.errors = []
    if (result.errors.length > 0) {
      field.errors = Array.from(result.errors)
    }
    this.setState({ fields })
  }

  validateTime = (moment, field) => {
    const time =
      typeof moment === 'string' ? moment : moment.format('hh:mm A')
    const { fields } = this.state
    field.value = time
    const result = approve.value(time, field.rules)
    field.errors = []
    if (result.errors.length > 0) {
      field.errors = Array.from(result.errors)
    }
    this.setState({fields})
  }

  getCountryCodesCommaDelimited = countryCodesDelimited => {
    let countryCodes = countryCodesDelimited.replace(new RegExp('^[|]+'), '')
    countryCodes = countryCodes.replace(new RegExp('[|]+$'), '')
    return countryCodes.replace(new RegExp('[|]+', 'g'), ',')
  }

  handleCountryListDisplay = countryCodesDelimited => {
    let result = countryCodesDelimited

    if (countryCodesDelimited.startsWith('|')) {
      const countryCodeArray = this.getCountryCodesCommaDelimited(countryCodesDelimited).split(',')

      const countryNames = []
      let i
      for (i = 0; i < countryCodeArray.length; i++) {
        const countryCode = countryCodeArray[i]
        var matchingCountry = this.countryOptions.filter(country => country.value === countryCode)

        if (matchingCountry && matchingCountry.length > 0) {
          const label = matchingCountry[0].label
          countryNames.push(label)
        }
      }

      result = countryNames.sort().join(', ')
    }

    return result
  }

  handleSiteMsgTrtanslations = translations => {
    var langs = translations.map(t => t.siteLanguage.language)
    return langs.sort().join(', ')
  }

  showSiteMessageEditModal = siteMsg => {
    const editFields = this.state.siteMsgEditFields
    editFields.title.value = siteMsg.title
    editFields.message.value = siteMsg.message

    editFields.language.value = siteMsg.siteLanguage.code
    editFields.messageType.value = siteMsg.siteMessageType.code
    editFields.showIcon.value = siteMsg.showIcon
    editFields.messageAppearance.value = siteMsg.siteMessageAppearance.code
    editFields.startDate.value = siteMsg.startDate
    editFields.endDate.value = siteMsg.endDate
    editFields.startDownTime.value = siteMsg.startDownTime
    editFields.endDownTime.value = siteMsg.endDownTime
    editFields.countrySelectionType.value = 'ALL'
    editFields.countries.value = ''

    if (siteMsg.countryCodesDelimited !== 'ALL') {
      if (siteMsg.countryCodesDelimited.startsWith('REGION:')) {
        editFields.countrySelectionType.value = siteMsg.countryCodesDelimited
      } else {
        editFields.countrySelectionType.value = 'SUBSET'
        editFields.countries.value = this.getCountryCodesCommaDelimited(siteMsg.countryCodesDelimited)
      }
    }

    // Reset errors
    editFields.title.errors = []
    editFields.message.errors = []
    editFields.messageType.errors = []
    editFields.showIcon.errors = []
    editFields.messageAppearance.errors = []
    editFields.startDate.errors = []
    editFields.endDate.errors = []
    editFields.startDownTime.errors = []
    editFields.endDownTime.errors = []
    editFields.countrySelectionType.errors = []
    editFields.countries.errors = []

    this.setState({
      siteMsgEditIsOpenModal: true,
      siteMsgEditFields: editFields,
      siteMsgEdit: siteMsg
    }, function () {
      this.forceUpdate()
    })
  }

  handleHideSiteMessageEditModal = () => {
    this.setState({ siteMsgEditIsOpenModal: false, siteMsgEdit: null })
  }

  handleSiteMessageDeletion = siteMsgId => {
    const msg = 'Are you sure you want to delete this message?'
    if (!window.confirm(msg)) {
      return false
    }

    api.deleteSiteMessage(
      siteMsgId,
      response => {
        // create toaster notification
        const { notify } = this.props
        const notification = {
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }

        if (response.status === 200) {
          this.loadSiteMsgList()
          notification.title = 'Success!'
          notification.message = 'Message was deleted'
          notification.status = 'success'
          notify(notification)
          this.handleResetCreateMessage()
        } else {
          notification.title = 'Error!'
          notification.status = 'error'
          if (response.status === 400) {
            response.text().then(errorMessage => {
              notification.message = errorMessage
              notify(notification)
            })
          } else if (response.status === 401) {
            notification.message =
              'You are not authorized to perform this action. Please log in again.'
            notify(notification)
            setTimeout(() => window.location.replace('/'), 3000)
          } else {
            notification.message = 'Something went wrong. Please try again later'
            notify(notification)
          }
        }
      },
      () => {
        const { notify } = this.props
        notify({
          title: 'Something went wrong!',
          message: 'Please try again later.',
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        })
      }
    )

    return false
  }

  handleCountriesChange = val => {
    const fields = this.state.fields
    fields.countries.value = val
    fields.countries.errors = []
    this.setState({ fields })
  }

  handleCountriesChangeEditModal = val => {
    const editFields = this.state.siteMsgEditFields
    editFields.countries.value = val
    editFields.countries.errors = []
    this.setState({ siteMsgEditFields: editFields })
  }

  handleListItemActionVisibility = (siteMsgId, isVisible) => {
    const divId = 'divListItemActions' + siteMsgId
    var div = document.getElementById(divId)
    div.style.display = isVisible ? '' : 'none'
  }

  handleTranslationActionVisibility = (languageCode, isVisible) => {
    const divId = 'divTranslationActions' + languageCode
    var div = document.getElementById(divId)
    div.style.display = isVisible ? '' : 'none'
  }

  render () {
    const length = this.state.siteMsgs[this.state.currentPage].length
    const startSiteMsgIndex = this.state.currentPage * 10 + 1
    return (
      <div id="manage-admin-list" className="v2_container">
        <div className="row">
          <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
          <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
            <div className="row manage-admin-list-header">
              <div className="col-12 col-xl-12">
                <h3 className="mb-3 header-primary">Manage Site Messages</h3>
                <p>
                  Hover over a row to edit or delete an item. Scroll below the
                  list to create a new message.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 col-xl-8">
                {this.state.siteMsgsLength === 0
                  ? "Displaying 0 siteMsgs"
                  : `Displaying ${startSiteMsgIndex}-${
                      startSiteMsgIndex + length - 1
                    } of ${this.state.siteMsgsLength} ${
                      this.state.siteMsgsLength === 1 ? "message" : "messages"
                    }`}
              </div>
              <div
                id="admin-list-search-container"
                className="col-lg-4 col-xl-4"
              >
                <input
                  id="site-message-search-input"
                  className="search"
                  type="text"
                  value={this.state.filterValue}
                  onChange={this.handleFilterList}
                  placeholder="Search for a message"
                />
                <span className="fa fa-search" />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-xl-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <TableHeader
                          columnName="message"
                          columnTitle="Message"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                          smallFont
                        />
                        <TableHeader
                          columnName="showIcon"
                          columnTitle="Icon"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                          smallFont
                        />
                        <TableHeader
                          columnName="startDate"
                          columnTitle="Start Date Time"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                          smallFont
                        />
                        <TableHeader
                          columnName="endDate"
                          columnTitle="End Date Time"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                          smallFont
                        />
                        <TableHeader
                          columnName="messageType"
                          columnTitle="Type"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                          smallFont
                        />
                        <TableHeader
                          columnName="language"
                          columnTitle="Language"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                          smallFont
                        />
                        <TableHeader
                          columnName="translations"
                          columnTitle="Translations"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={TABLE_HEADER_COLUMN_NO_SORT}
                          smallFont
                        />
                        <TableHeader
                          columnName="countries"
                          columnTitle="Countries"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={TABLE_HEADER_COLUMN_NO_SORT}
                          smallFont
                        />
                        <TableHeader
                          columnName="messageAppearance"
                          columnTitle="Display"
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={this.state.sortDirection}
                          smallFont
                        />
                        <TableHeader
                          columnName="actions"
                          columnTitle=""
                          onSort={this.handleSort}
                          sortColumn={this.state.sortColumn}
                          sortDirection={TABLE_HEADER_COLUMN_NO_SORT}
                          smallFont
                        />
                      </tr>
                    </thead>
                    <tbody>
                      {length !== 0 ? (
                        this.state.siteMsgs[this.state.currentPage].map(
                          (siteMsg, i) => {
                            return (
                              <tr
                                key={i}
                                className={
                                  !moment
                                    .utc()
                                    .isSameOrBefore(
                                      moment(siteMsg.endDate),
                                      "day"
                                    )
                                    ? "expired-item"
                                    : null
                                }
                                onMouseOver={() =>
                                  this.handleListItemActionVisibility(
                                    siteMsg.id,
                                    true
                                  )
                                }
                                onMouseOut={() =>
                                  this.handleListItemActionVisibility(
                                    siteMsg.id,
                                    false
                                  )
                                }
                              >
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  title={siteMsg.title}
                                  value={decodeURIComponent(siteMsg.message)}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="message"
                                  maxLength={25}
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  value={siteMsg.showIcon === "Y" ? "Icon" : ""}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="showIcon"
                                  maxLength={255}
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  name="dateTime"
                                  value1={siteMsg.startDate}
                                  value2={siteMsg.startDownTime}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="startDate"
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  name="dateTime"
                                  value1={siteMsg.endDate}
                                  value2={siteMsg.endDownTime}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="endDate"
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  value={siteMsg.siteMessageType.type}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="messageType"
                                  maxLength={255}
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  value={siteMsg.siteLanguage.language}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="language"
                                  maxLength={255}
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  value={this.handleSiteMsgTrtanslations(
                                    siteMsg.translations
                                  )}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="translations"
                                  maxLength={255}
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  value={siteMsg.countryNamesDelimited}
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="countries"
                                  maxLength={255}
                                  smallFont
                                />
                                <TableCell
                                  editInline={null}
                                  edit={null}
                                  value={
                                    siteMsg.siteMessageAppearance.appearance
                                  }
                                  onChange={null}
                                  updateAfterEdit={null}
                                  cancelEdit={null}
                                  index={i}
                                  column="messageAppearance"
                                  maxLength={255}
                                  smallFont
                                />
                                <td
                                  className="item-cell small-font"
                                  style={{
                                    verticalAlign: "top",
                                    minWidth: "46px",
                                    maxWidth: "46px",
                                  }}
                                >
                                  <div
                                    id={`divListItemActions${siteMsg.id}`}
                                    style={{ display: "none" }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <div style={{ border: "0px solid blue" }}>
                                        <a
                                          role="button"
                                          onClick={() => {
                                            this.showSiteMessageEditModal(
                                              siteMsg
                                            );
                                            return false;
                                          }}
                                          style={{
                                            textDecoration: "none",
                                            borderBottom: "0px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              padding: "5px 0px 0px 5px",
                                            }}
                                            className="fa fa-pencil fa-lg"
                                          />
                                        </a>
                                      </div>
                                      <div
                                        style={{
                                          paddingLeft: "8px",
                                          paddingRight: "6px",
                                        }}
                                      >
                                        <a
                                          role="button"
                                          onClick={() => {
                                            this.handleSiteMessageDeletion(
                                              siteMsg.id
                                            );
                                            return false;
                                          }}
                                          style={{
                                            textDecoration: "none",
                                            borderBottom: "0px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              lineHeight: "22px",
                                              fontSize: "24px",
                                              color: "#888",
                                              border: "0px solid orange",
                                            }}
                                          >
                                            &times;
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : (
                        <tr>
                          <td style={{ textAlign: "center" }} colSpan={9}>
                            {"There are no results. Please try again."}
                          </td>
                        </tr>
                      )}
                      <PageNav
                        pages={this.state.siteMsgs.length}
                        currentPage={this.state.currentPage}
                        onPageBackward={this.handlePageBackward}
                        onPageForward={this.handlePageForward}
                        onPageNav={this.handlePageNav}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 title">Create a Message</div>
            </div>
            <div className="row">
              <div className="col-lg-2 m-b-15">
                <Select
                  searchable
                  clearable={false}
                  options={this.siteMsgTypeOptions}
                  onChange={null}
                  field={this.state.fields.messageType}
                  validate={(e, field) =>
                    this.validate(e, this.state.fields.messageType)
                  }
                />
              </div>
              <div className="col-lg-2 m-b-15">
                <Select
                  searchable
                  clearable={false}
                  options={this.showIconOptions}
                  onChange={null}
                  field={this.state.fields.showIcon}
                  validate={(e, field) =>
                    this.validate(e, this.state.fields.showIcon)
                  }
                />
              </div>
              <div className="col-lg-4 m-b-15">
                <Select
                  searchable
                  clearable={false}
                  options={this.siteMsgAppearanceOptions}
                  onChange={null}
                  field={this.state.fields.messageAppearance}
                  validate={(e, field) =>
                    this.validate(e, this.state.fields.messageAppearance)
                  }
                />
              </div>
              <div className="col-lg-4 m-b-15">
                <Select
                  searchable
                  clearable={false}
                  options={SITE_LANGUAGES_ENGLISH}
                  onChange={null}
                  field={this.state.fields.language}
                  validate={(e, field) =>
                    this.validate(e, this.state.fields.language)
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 m-b-15">
                <Select
                  searchable
                  clearable={false}
                  options={this.countrySelectionTypeOptions}
                  onChange={null}
                  field={this.state.fields.countrySelectionType}
                  validate={(e, field) =>
                    this.validate(e, this.state.fields.countrySelectionType)
                  }
                />
              </div>
              <div className="col-lg-4 m-b-15">
                <Datetime
                  input
                  renderInput={(_props, openCalendar, _closeCalendar) => {
                    return (
                      <InputGroup
                        searchable={false}
                        clearable={false}
                        field={this.state.fields.startDate}
                        validate={() => true}
                        onFocus={openCalendar}
                        readonly
                      />
                    );
                  }}
                  dateFormat="YYYY-MM-DD"
                  timeFormat={false}
                  viewMode="days"
                  onChange={(moment) => {
                    this.validateDatetime(moment, this.state.fields.startDate);
                  }}
                  onBlur={(moment) => {
                    this.validateDatetime(moment, this.state.fields.startDate);
                  }}
                  onFocus={() => {
                    window.scrollTo(0, document.body.scrollHeight);
                  }}
                  closeOnSelect
                />
              </div>
              <div className="col-lg-4 m-b-15">
                <Datetime
                  input
                  renderInput={(_props, openCalendar, _closeCalendar) => {
                    return (
                      <InputGroup
                        searchable={false}
                        clearable={false}
                        field={this.state.fields.startDownTime}
                        validate={() => true}
                        onFocus={openCalendar}
                        readonly
                      />
                    );
                  }}
                  dateFormat={false}
                  timeFormat="hh:mm A"
                  viewMode="time"
                  utc={true}
                  onChange={(moment) => {
                    this.validateTime(moment, this.state.fields.startDownTime);
                  }}
                  onBlur={(moment) => {
                    this.validateTime(moment, this.state.fields.startDownTime);
                  }}
                  onFocus={() => {
                    // window.scrollTo(0, document.body.scrollHeight)
                  }}
                  closeOnSelect
                />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 m-b-15">
                <Datetime
                  input
                  renderInput={(_props, openCalendar, _closeCalendar) => {
                    return (
                      <InputGroup
                        searchable={false}
                        clearable={false}
                        field={this.state.fields.endDate}
                        validate={() => true}
                        onFocus={openCalendar}
                        readonly
                      />
                    );
                  }}
                  dateFormat="YYYY-MM-DD"
                  timeFormat={false}
                  viewMode="days"
                  onChange={(moment) => {
                    this.validateDatetime(moment, this.state.fields.endDate);
                  }}
                  onBlur={(moment) => {
                    this.validateDatetime(moment, this.state.fields.endDate);
                  }}
                  onFocus={() => {
                    window.scrollTo(0, document.body.scrollHeight);
                  }}
                  closeOnSelect
                />
              </div>
              <div className="col-lg-4 m-b-15">
                <Datetime
                  input
                  renderInput={(_props, openCalendar, _closeCalendar) => {
                    return (
                      <InputGroup
                        searchable={false}
                        clearable={false}
                        field={this.state.fields.endDownTime}
                        validate={() => true}
                        onFocus={openCalendar}
                        readonly
                      />
                    );
                  }}
                  dateFormat={false}
                  timeFormat="hh:mm A"
                  viewMode="time"
                  utc={true}
                  onChange={(moment) => {
                    this.validateTime(moment, this.state.fields.endDownTime);
                  }}
                  onBlur={(moment) => {
                    this.validateTime(moment, this.state.fields.endDownTime);
                  }}
                  onFocus={() => {
                    // window.scrollTo(0, document.body.scrollHeight)
                  }}
                  closeOnSelect
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                display:
                  this.state.fields.countrySelectionType.value === "SUBSET"
                    ? ""
                    : "none",
              }}
            >
              <div className="col-lg-12 m-b-15">
                <SelectMultiple
                  field={this.state.fields.countries}
                  options={this.countryOptions}
                  placeHolder="Select Countries"
                  onChange={(val) => this.handleCountriesChange(val)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <InputGroup
                  maxLength={4096}
                  field={this.state.fields.title}
                  validate={(e, field) =>
                    this.validate(e, this.state.fields.title)
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <Textarea
                  rows={5}
                  maxLength={4096}
                  field={this.state.fields.message}
                  validate={(e, field) =>
                    this.validate(e, this.state.fields.message)
                  }
                  comment={this.includeLinkComment}
                />
              </div>
            </div>
            <div className="row">
              <div className="col form-group">
                <button
                  type="submit"
                  onClick={this.handleSubmitCreateMessage}
                  className="btn btn-lg btn-info submit-button btn-rounded"
                >
                  {"Create Message"}
                </button>
                <button
                  type="button"
                  onClick={this.handleResetCreateMessage}
                  className="btn btn-primary btn-outline hover btn-lg btn-icon reset-button btn-rounded"
                >
                  {"Reset"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Edit modal - start */}
        <div>
          <Modal
            className="site-msg-edit-modal"
            isOpen={this.state.siteMsgEditIsOpenModal}
            backdrop
            keyboard={false}
            wrapClassName="modal-primary"
            size="lg"
          >
            <ModalHeader toggle={() => this.handleHideSiteMessageEditModal()}>
              Edit Message
            </ModalHeader>
            <ModalBody>
              <div className="container" style={{ margin: "3px" }}>
                <div className="row">
                  <div className="col-lg-2 m-b-15">
                    <Select
                      searchable
                      clearable={false}
                      options={this.siteMsgTypeOptions}
                      onChange={null}
                      field={this.state.siteMsgEditFields.messageType}
                      validate={(e, field) =>
                        this.validate(
                          e,
                          this.state.siteMsgEditFields.messageType
                        )
                      }
                    />
                  </div>
                  <div className="col-lg-2 m-b-15">
                    <Select
                      searchable
                      clearable={false}
                      options={this.showIconOptions}
                      onChange={null}
                      field={this.state.siteMsgEditFields.showIcon}
                      validate={(e, field) =>
                        this.validate(e, this.state.siteMsgEditFields.showIcon)
                      }
                    />
                  </div>
                  <div className="col-lg-4 m-b-15">
                    <Select
                      searchable
                      clearable={false}
                      options={this.siteMsgAppearanceOptions}
                      onChange={null}
                      field={this.state.siteMsgEditFields.messageAppearance}
                      validate={(e, field) =>
                        this.validate(
                          e,
                          this.state.siteMsgEditFields.messageAppearance
                        )
                      }
                    />
                  </div>
                  <div className="col-lg-4 m-b-15">
                    <Select
                      searchable
                      clearable={false}
                      options={SITE_LANGUAGES_ENGLISH}
                      onChange={null}
                      field={this.state.siteMsgEditFields.language}
                      validate={(e, field) =>
                        this.validate(e, this.state.siteMsgEditFields.language)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 m-b-15">
                    <Select
                      searchable
                      clearable={false}
                      options={this.countrySelectionTypeOptions}
                      onChange={null}
                      field={this.state.siteMsgEditFields.countrySelectionType}
                      validate={(e, field) =>
                        this.validate(
                          e,
                          this.state.siteMsgEditFields.countrySelectionType
                        )
                      }
                    />
                  </div>
                  <div className="col-lg-4 m-b-15">
                    <Datetime
                      input
                      renderInput={(_props, openCalendar, _closeCalendar) => {
                        return (
                          <InputGroup
                            searchable={false}
                            clearable={false}
                            field={this.state.siteMsgEditFields.startDate}
                            validate={() => true}
                            onFocus={openCalendar}
                            readonly
                          />
                        );
                      }}
                      dateFormat="YYYY-MM-DD"
                      timeFormat={false}
                      viewMode="days"
                      onChange={(moment) => {
                        this.validateDatetime(
                          moment,
                          this.state.siteMsgEditFields.startDate
                        );
                      }}
                      onBlur={(moment) => {
                        this.validateDatetime(
                          moment,
                          this.state.siteMsgEditFields.startDate
                        );
                      }}
                      onFocus={() => {
                        // window.scrollTo(0, document.body.scrollHeight)
                      }}
                      closeOnSelect
                    />
                  </div>
                  <div className="col-lg-4 m-b-15">
                    <Datetime
                      input
                      renderInput={(_props, openCalendar, _closeCalendar) => {
                        return (
                          <InputGroup
                            searchable={false}
                            clearable={false}
                            field={this.state.siteMsgEditFields.startDownTime}
                            validate={() => true}
                            onFocus={openCalendar}
                            readonly
                          />
                        );
                      }}
                      dateFormat={false}
                      timeFormat="hh:mm A"
                      viewMode="time"
                      utc={true}
                      initialValue={this.state.siteMsgEditFields.startDownTime}
                      onChange={(moment) => {
                        this.validateTime(
                          moment,
                          this.state.siteMsgEditFields.startDownTime
                        );
                      }}
                      onBlur={(moment) => {
                        this.validateTime(
                          moment,
                          this.state.siteMsgEditFields.startDownTime
                        );
                      }}
                      onFocus={() => {
                        // window.scrollTo(0, document.body.scrollHeight)
                      }}
                      closeOnSelect
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 m-b-15">
                    <Datetime
                      input
                      renderInput={(_props, openCalendar, _closeCalendar) => {
                        return (
                          <InputGroup
                            searchable={false}
                            clearable={false}
                            field={this.state.siteMsgEditFields.endDate}
                            validate={() => true}
                            onFocus={openCalendar}
                            readonly
                          />
                        );
                      }}
                      dateFormat="YYYY-MM-DD"
                      timeFormat={false}
                      viewMode="days"
                      onChange={(moment) => {
                        this.validateDatetime(
                          moment,
                          this.state.siteMsgEditFields.endDate
                        );
                      }}
                      onBlur={(moment) => {
                        this.validateDatetime(
                          moment,
                          this.state.siteMsgEditFields.endDate
                        );
                      }}
                      onFocus={() => {
                        // window.scrollTo(0, document.body.scrollHeight)
                      }}
                      closeOnSelect
                    />
                  </div>
                  <div className="col-lg-4 m-b-15">
                    <Datetime
                      input
                      renderInput={(_props, openCalendar, _closeCalendar) => {
                        return (
                          <InputGroup
                            searchable={false}
                            clearable={false}
                            field={this.state.siteMsgEditFields.endDownTime}
                            validate={() => true}
                            onFocus={openCalendar}
                            readonly
                          />
                        );
                      }}
                      initialValue={this.state.siteMsgEditFields.endDownTime}
                      dateFormat={false}
                      timeFormat="hh:mm A"
                      viewMode="time"
                      utc={true}
                      onChange={(moment) => {
                        this.validateTime(
                          moment,
                          this.state.siteMsgEditFields.endDownTime
                        );
                      }}
                      onBlur={(moment) => {
                        this.validateTime(
                          moment,
                          this.state.siteMsgEditFields.endDownTime
                        );
                      }}
                      onFocus={() => {
                        // window.scrollTo(0, document.body.scrollHeight)
                      }}
                      closeOnSelect
                    />
                  </div>
                </div>
                <div
                  className="row"
                  style={{
                    display:
                      this.state.siteMsgEditFields.countrySelectionType
                        .value === "SUBSET"
                        ? ""
                        : "none",
                  }}
                >
                  <div className="col-lg-12 m-b-15">
                    <SelectMultiple
                      field={this.state.siteMsgEditFields.countries}
                      options={this.countryOptions}
                      placeHolder="Select Countries"
                      onChange={(val) =>
                        this.handleCountriesChangeEditModal(val)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <InputGroup
                      maxLength={4096}
                      field={this.state.siteMsgEditFields.title}
                      validate={(e, field) =>
                        this.validate(e, this.state.siteMsgEditFields.title)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <Textarea
                      rows={5}
                      maxLength={4096}
                      field={this.state.siteMsgEditFields.message}
                      validate={(e, field) =>
                        this.validate(e, this.state.siteMsgEditFields.message)
                      }
                      comment={this.includeLinkComment}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12" style={{ display: "flex" }}>
                    <div>
                      <button
                        type="submit"
                        onClick={this.handleSubmitEditMessage}
                        className="btn btn-md btn-info submit-button btn-rounded"
                        style={{ lineHeight: "22px" }}
                      >
                        {"Save Message"}
                      </button>
                    </div>
                    <div style={{ paddingLeft: "10px" }}>
                      <button
                        type="button"
                        onClick={this.handleHideSiteMessageEditModal}
                        className="btn btn-primary btn-md btn-outline hover btn-icon reset-button btn-rounded"
                      >
                        {"Cancel"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="manage-admin-list" className="container">
                <div className="row">
                  <div className="col-12 title m-b-20 m-t-0">
                    Message Translations
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-xl-12">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <TableHeader
                              columnName="language"
                              columnTitle="Language"
                              onSort={null}
                              sortColumn="N/A"
                              sortDirection={TABLE_HEADER_COLUMN_NO_SORT}
                              narrowColumn
                            />
                            <TableHeader
                              columnName="translation"
                              columnTitle="Translation"
                              onSort={null}
                              sortColumn="N/A"
                              sortDirection={TABLE_HEADER_COLUMN_NO_SORT}
                            />
                            <TableHeader
                              columnName="actions"
                              columnTitle=""
                              onSort={null}
                              sortColumn={this.state.sortColumn}
                              sortDirection={TABLE_HEADER_COLUMN_NO_SORT}
                            />
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.siteMsgEdit &&
                          this.state.siteMsgEdit.translations &&
                          this.state.siteMsgEdit.translations.length !== 0 ? (
                            this.state.siteMsgEdit.translations.map(
                              (translation, i) => {
                                return (
                                  <tr
                                    key={i}
                                    onMouseOver={() =>
                                      this.handleTranslationActionVisibility(
                                        translation.siteLanguage.code,
                                        true
                                      )
                                    }
                                    onMouseOut={() =>
                                      this.handleTranslationActionVisibility(
                                        translation.siteLanguage.code,
                                        false
                                      )
                                    }
                                  >
                                    <TableCell
                                      editInline={null}
                                      edit={null}
                                      value={translation.siteLanguage.language}
                                      onChange={null}
                                      updateAfterEdit={null}
                                      cancelEdit={null}
                                      index={i}
                                      column="language"
                                      maxLength={255}
                                    />
                                    <TableCell
                                      editInline={null}
                                      edit={this.state.edit}
                                      value={decodeURIComponent(
                                        translation.messageTranslation
                                      )}
                                      onChange={null}
                                      updateAfterEdit={null}
                                      cancelEdit={null}
                                      index={i}
                                      column="translation"
                                      maxLength={255}
                                      title={translation.titleTranslation}
                                    />
                                    <td
                                      className="item-cell small-font"
                                      style={{
                                        verticalAlign: "top",
                                        minWidth: "30px",
                                        maxWidth: "30px",
                                      }}
                                    >
                                      <div
                                        id={`divTranslationActions${translation.siteLanguage.code}`}
                                        style={{ display: "none" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <div>&nbsp;</div>
                                          <div
                                            style={{
                                              paddingLeft: "8px",
                                              paddingRight: "6px",
                                            }}
                                          >
                                            <a
                                              role="button"
                                              onClick={(e) => {
                                                this.handleTranslationDeletion(
                                                  e,
                                                  translation.siteLanguage.code
                                                );
                                                return false;
                                              }}
                                              style={{
                                                textDecoration: "none",
                                                borderBottom: "0px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  lineHeight: "22px",
                                                  fontSize: "24px",
                                                  color: "#888",
                                                  border: "0px solid orange",
                                                }}
                                              >
                                                &times;
                                              </div>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          ) : (
                            <tr>
                              <td style={{ textAlign: "center" }} colSpan={3}>
                                {"There are no translations."}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 title">Create a Translation</div>
                </div>
                <div className="row">
                  <div className="col-lg-4 m-b-15">
                    <Select
                      searchable
                      clearable={false}
                      options={
                        this.state.siteMsgEdit &&
                        this.state.siteMsgEdit.siteLanguage
                          ? SITE_LANGUAGES_ENGLISH.filter(
                              (lang) =>
                                lang.value !==
                                this.state.siteMsgEdit.siteLanguage.code
                            )
                          : SITE_LANGUAGES_ENGLISH
                      }
                      onChange={null}
                      field={this.state.createTranslationFields.language}
                      validate={(e, field) =>
                        this.validate(
                          e,
                          this.state.createTranslationFields.language
                        )
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <InputGroup
                      maxLength={4096}
                      field={this.state.createTranslationFields.title}
                      validate={(e, field) =>
                        this.validate(
                          e,
                          this.state.createTranslationFields.title
                        )
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <Textarea
                      rows={5}
                      maxLength={4096}
                      field={this.state.createTranslationFields.translation}
                      validate={(e, field) =>
                        this.validate(
                          e,
                          this.state.createTranslationFields.translation
                        )
                      }
                      comment={this.includeLinkComment}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col form-group">
                    <button
                      type="submit"
                      onClick={this.handleSubmitCreateTranslation}
                      className="btn btn-md btn-info submit-button btn-rounded"
                    >
                      {"Create Translation"}
                    </button>
                    <button
                      type="button"
                      onClick={this.handleResetCreateTranslation}
                      className="btn btn-primary btn-outline hover btn-md btn-icon reset-button btn-rounded"
                    >
                      {"Reset"}
                    </button>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
        {/* Edit modal - end */}
      </div>
    );
  }
}

function PageNav (props) {
  const isFirstPage = props.currentPage === 0
  const isLastPage = props.currentPage === props.pages - 1
  const pageNav = []
  for (let index = 0; index < props.pages; index++) {
    index > props.currentPage - 5 &&
    pageNav.length < 5 &&
    pageNav.push(
      index === props.currentPage ? (
        <span className='pageNavCenter' key={index}>
          <b className='centerCurrent'>{index + 1}</b>
        </span>
      ) : (
        <span className='pageNavCenter' key={index}>
          <span
            className='centerContent'
            onClick={() => props.onPageNav(index)}
          >
            {index + 1}
          </span>
        </span>
      )
    )
  }

  pageNav.unshift(
    <span className='pageNavLeft' key='left'>
      {!isFirstPage ? (
        <span className='leftContent' onClick={props.onPageBackward}>
          {'<'}
        </span>
      ) : (
        <span className='arrowDisabled'>{'<'}</span>
      )}
    </span>
  )

  pageNav.push(
    <span className='pageNavRight' key='right'>
      {!isLastPage ? (
        <span className='rightContent' onClick={props.onPageForward}>
          {'>'}
        </span>
      ) : (
        <span className='arrowDisabled'>{'>'}</span>
      )}
    </span>
  )
  return (
    <tr>
      <td className='pageNav' style={{ textAlign: 'center' }} colSpan={9}>
        {pageNav}
      </td>
    </tr>
  )
}

function TableHeader (props) {
  const mapSortColumnToColumnName = sortColumn => {
    let columnName = sortColumn
    switch (sortColumn) {
      case 'siteMessageTypeSort':
        columnName = 'messageType'
        break
      case 'siteMessageAppearanceSort':
        columnName = 'messageAppearance'
        break
      case 'siteLanguageSort':
        columnName = 'language'
        break
      default:
        break
    }
    return columnName
  }

  const mappedSortColumnName = mapSortColumnToColumnName(props.sortColumn)

  return (
    <th
      className={`column-header ${props.smallFont ? 'small-font' : ''} ${props.narrowColumn ? 'narrow-column' : ''}`}
      onClick={() => {
        if (props.onSort) {
          props.onSort(props.columnName)
        }
      }}
    >
      {props.columnTitle}
      {
        props.sortDirection === TABLE_HEADER_COLUMN_NO_SORT ? null : (
          <span
            className={`fa fa-sort${
              (mappedSortColumnName === props.columnName) && props.sortDirection !== ''
                ? '-' + (props.sortDirection === 'down' ? 'up' : 'down')
                : ''
            }`}
          />)
      }
    </th>
  )
}

function TableCell (props) {
  return (
    <td className={`item-cell ${props.smallFont ? "small-font" : ""} `}>
      {props.title ? (
        <div
          style={{
            fontWeight: "bold",
            paddingBottom: "5px",
          }}
        >
          {props.title}
        </div>
      ) : null}
      {props.name === "dateTime" ? (
        <div>
          <div>{props.value1}</div>
          <div>{props.value2}</div>
        </div>
      ) : (
        <span>{props.value}</span>
      )}
    </td>
  );
}

function mapStateToProps () {
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ notify }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageSiteMessages)



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/ManageSiteMessages.js